import * as React from 'react';
import Avatar from '@mui/material/Avatar';

import { nomAthlete, type AthleteRattache } from '../Auth/moi.ts';

/** Photo Google de l'athlete (initiale a defaut). */
export default function AvatarAthlete({ athlete, taille = 32 }: { athlete: AthleteRattache; taille?: number }) {
  const nom = nomAthlete(athlete);
  return (
    <Avatar
      alt={nom}
      src={athlete.photo ?? undefined}
      // Les photos Google (lh3.googleusercontent.com) sont parfois refusees
      // quand un referer est envoye (cf Menu.tsx).
      imgProps={{ referrerPolicy: 'no-referrer' }}
      sx={{ width: taille, height: taille, fontSize: taille * 0.45 }}
    >
      {nom.charAt(0).toUpperCase()}
    </Avatar>
  );
}
